import { axios } from 'api'

const getAllUser = () => axios.get('/user')

const addOrUpdateUser = (
  username: string,
  password: string,
  email: string,
  role: string,
  company: string
) =>
  axios
    .post(`/user`, {
      username,
      password,
      email,
      role,
      company
    })
    .catch(err => {
      console.error(err)
    })

const deleteUser = (userId: string) =>
  axios
    .delete(`/user`, {
      data: { userId }
    })
    .catch(err => {
      console.error(err)
    })

export { addOrUpdateUser, getAllUser, deleteUser }
